import React from 'react';

const clientId = '7bd5eb753d274f2b879b3ce5483bd037';
const redirectUri = "http://music.openre.org/";
let userAccessToken;

const Spotify  = {

    getAccessToken() {
        const urlToParse=window.location.href;  
        
        if (userAccessToken) {
           return userAccessToken;
        }
        else if (urlToParse.match(/access_token=([^&]*)/)) {
           
            //Parse url and get token and expiration time:
            
            const expireTime=urlToParse.match(/expires_in=([^&]*)/)[1];
            userAccessToken=urlToParse.match(/access_token=([^&]*)/)[1];
            window.setTimeout(() => userAccessToken = '', expireTime * 1000);
            window.history.pushState('Access Token', null, '/');
            return userAccessToken;
               
        } else {
            const url = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=token&scope=playlist-modify-public,playlist-modify-private&redirect_uri=${redirectUri}`;
            window.location = url;
        }
    },
    search(userTerm) {
        const endpoint = 'https://api.spotify.com/v1/search?type=track&q=' + userTerm;
         //console.log(this.getAccessToken())  ;          
        return fetch(endpoint, {
            headers: {
                Authorization: 'Bearer '+ this.getAccessToken()
            }
        })
        .then(response => response.json())
        .then (data => {
            //console.log(data);
            if (!data.tracks) {
                return [];
            } else {
            return data.tracks.items.map(item => {
                return {
                    id: item.id,
                    name: item.name,
                    artist: item.artists[0].name,
                    album: item.album.name,
                    uri: item.uri
                }
            })
            }   
        });
    },

    savePlaylist(playlistName, trackUris) {
        
        if(playlistName && trackUris.length) {
            const headers = {
                Authorization: 'Bearer '+ this.getAccessToken(),
                'Content-Type': 'application/json'
            };
            let userId;
            let playlistId;
            let snapshotId;
            const endpoint = 'https://api.spotify.com/v1/me';
                     
            return fetch(endpoint, {
                headers: headers}
            )
            .then(response => response.json())
            .then ((data) => {
                userId=data.id;
                const endpoint = 'https://api.spotify.com/v1/users/'+userId+'/playlists';
                return fetch(endpoint, {
                    headers: headers,
                    method: 'POST',
                    body: JSON.stringify({name: playlistName})
                });
                
            })
            .then((response) => response.json())
            .then ((data) => {
                playlistId=data.id;
                const endpoint = 'https://api.spotify.com/v1/playlists/'+playlistId+'/tracks';
                return fetch(endpoint, {
                    headers: headers,
                    method: 'POST',
                    body: JSON.stringify({uris: trackUris})
                });
            })
            .then((response) => response.json())
            .then ((data) => {
                snapshotId=data.snapshot_id;
                return snapshotId;
            })
        } else {
            return;
        }
    },

    getLibrary() {
        const accessToken = this.getAccessToken();
        if(accessToken===undefined) {
            return Promise.resolve([]);
        }
        const headers = {
            Authorization: 'Bearer '+ accessToken,
            'Content-Type': 'application/json'
        };
                             
        return fetch('https://api.spotify.com/v1/me', {
            headers: headers}
        )
        .then(response => response.json())
        .then ((user) => {
            return fetch('https://api.spotify.com/v1/users/'+user.id+'/playlists', {
                headers: headers})
        }
        )     
        
        .then(response => response.json())
        .then ((data) => {
            console.log(data);
            return data.items.map((item) => {
                return {
                    title: item.name,
                    id: item.id
                }
            });
        })
    },

    getLibraryTracks(playlistId) {
        const accessToken = this.getAccessToken();
        const endpoint = 'https://api.spotify.com/v1/playlists/'+playlistId+'/tracks';
        
        const headers = {
            Authorization: 'Bearer '+ accessToken,
            'Content-Type': 'application/json'
        }
        
        return fetch (endpoint, {headers: headers})
        
        .then (response => response.json())
        .then ((data) => {
        
            return data.items.map(item => {
                item = item.track;
                return {
                    id: item.id,
                    name: item.name,
                    artist: item.artists[0].name,
                    album: item.album.name,
                    uri: item.uri
                }
            })
        })
    },

    updatePlaylist(playlistId, trackUris) {
        console.log('Im updating');
        const headers = {
            Authorization: 'Bearer '+ this.getAccessToken(),
            'Content-Type': 'application/json'
        };
        const endpoint = 'https://api.spotify.com/v1/playlists/'+playlistId+'/tracks';
        return fetch (endpoint, {
            headers: headers,
            method: 'PUT',
            body: JSON.stringify({uris: trackUris})
        });
    },

    deletePlaylist(playlistId) {
        
        const headers = {
            Authorization: 'Bearer '+ this.getAccessToken(),
            'Content-Type': 'application/json'
        };
        const endpoint = 'https://api.spotify.com/v1/playlists/'+playlistId+'/followers';
        return fetch (endpoint, {
            headers: headers,
            method: 'DELETE'
        });
    }
          
};


export default Spotify;
